import { render, staticRenderFns } from "./SalaryEffectsTable.vue?vue&type=template&id=629c73f6&"
import script from "./SalaryEffectsTable.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports